import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import Form from 'components/common/Form';
import Input from 'components/common/Form/Input';
import Button from 'components/common/Form/Button';
import {ButtonStyles} from 'components/common/Form/Button';

import style from 'components/Welcome/Form/Form.module.scss';
import MultiSwitch from 'components/common/Form/MultiSwitch/MultiSwitch';
import {convertToOptions, convertToValue} from 'helpers/SelectUtils';
import CompanyTypes from 'constants/CompanyTypes';
import Select from 'components/common/Form/Select';
import {TranslateIndustries} from 'constants/BusinessInformation';
import CheckBox from 'components/common/Form/CheckBox';
import {isCompanyAdmin, isModerator, isTranslator} from 'constants/UserRoles';
import cn from 'classnames';
import LoadingSpinner from 'components/common/LoadingSpinner/LoadingSpinner';

export default function AboutCompanyForm({
    data,
    onChange,
    onPreviousStep,
    onNextStep,
    errors,
    isLastStep,
    validateVat,
    hasVat,
    switchVat,
    validate,
    role,
    isModal,
    vatLoading,
}) {
    const {name, type, vat, companyIndustry} = data;
    const {t} = useTranslation();
    useEffect(() => {
        if (!hasVat) {
            onChange('vat', '');
        }
    }, [hasVat]);
    const isTranslatorOrModerator = isTranslator(role) || isModerator(role);
    const vatButtonText = vatLoading ? (
        <LoadingSpinner className={style.vatLoader} spinnerProps={{size: 30}} />
    ) : (
        t('common.check')
    );
    return (
        <div className={style.profileFormContainer}>
            <Form className={cn(style.form, {[style.wideForm]: isTranslatorOrModerator, [style.modal]: isModal})}>
                <div className={style.inlineFieldsContainer}>
                    <Input
                        label={t('welcome:form.labels.vat')}
                        name='vat'
                        placeholder={'GB123456789'}
                        value={vat}
                        onChange={onChange.bind(this, 'vat')}
                        error={t(errors.vat)}
                        labelClassName={style.labelClassName}
                        disabled={!hasVat}
                        errorAbsolutePosition
                    />
                    <Button
                        btnStyle={ButtonStyles.secondary}
                        className={style.vatButton}
                        text={vatButtonText}
                        disabled={!hasVat}
                        onClick={e => validateVat(e)}
                    />
                    <CheckBox
                        label={t('welcome:form.labels.vatRegistered')}
                        className={style.checkBox}
                        value={hasVat}
                        onChange={switchVat}
                        enabled
                    />
                </div>
                <div className={style.inlineFieldsContainer}>
                    <Input
                        label={t('welcome:form.labels.company')}
                        name='name'
                        placeholder={t('welcome:form.placeholders.company')}
                        value={name}
                        onChange={onChange.bind(this, 'name')}
                        error={t(errors.companyName)}
                        labelClassName={style.labelClassName}
                        onBlur={validate.bind(this, data, 'companyName')}
                        firstCapitalized
                    />
                </div>
                <div className={style.inlineFieldsContainer}>
                    <div className={style.gender}>
                        <span>{t('welcome:form.labels.companyType')}</span>
                        <MultiSwitch
                            onChange={onChange.bind(this, 'type')}
                            options={convertToOptions(CompanyTypes)}
                            value={type}
                        />
                    </div>
                </div>
                {isCompanyAdmin(role) && (
                    <div className={style.inlineFieldsContainer}>
                        <Select
                            label={t('welcome:form.labels.companyIndustry')}
                            placeholder={t('welcome:form.placeholders.companyIndustry')}
                            options={convertToOptions(TranslateIndustries(t))}
                            value={convertToValue(companyIndustry, TranslateIndustries(t))}
                            onChange={onChange.bind(this, 'companyIndustry')}
                            error={t(errors.companyIndustry)}
                            labelClassName={style.labelClassName}
                            onBlur={validate.bind(this, data, 'companyIndustry')}
                        />
                    </div>
                )}
                {isLastStep && <div className={style.commonError}>{errors.common}</div>}
                <div className={style.buttonWrapper}>
                    <Button text={t('welcome:buttons.continue')} btnStyle={ButtonStyles.primary} onClick={onNextStep} />
                </div>
            </Form>
        </div>
    );
}
